import type * as React from "react";
import { connect } from "react-redux";
import {
    KeywordGeneratorToolPageTableBase,
    mapDispatchToPropsBase,
    mapStateToPropsBase,
} from "./KeywordGeneratorToolPageBase";
import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";
import { shortMonthAndYear } from "@similarweb/pro-logic-components";
import { PhraseMatchTableSettings } from "./PhraseMatchTableSettings";
import { paramsWithUpdatedRangeFilterAndKeyword } from "./KeywordGeneratorToolPageTable";
import { capitalizeIntent } from "app/pages/keyword-research/keyword-analysis/pages/keyword-generator/google-keyword-generator/utils";
import { getVolumeValue } from "app/pages/website-analysis/traffic-sources/search/common/utils";
import {
    LABELS_FOR_TABLE_TYPES,
    TABLE_TYPES_FOR_ENDPOINT,
} from "app/common/keyword-research/keyword-generator/constants";
import type { IGoogleKeywordGeneratorApiResponse } from "app/common/keyword-research/keyword-generator/types";

class KeywordGeneratorToolPageQuestionsTable extends KeywordGeneratorToolPageTableBase {
    protected tableSettings = PhraseMatchTableSettings;
    protected tableStorageKey = "KeywordGeneratorToolQuestionTable";
    protected dropdownAppendTo = ".fourthTab .swReactTable-header-wrapper";

    protected dataParamsAdapter = (params) => {
        return {
            ...paramsWithUpdatedRangeFilterAndKeyword(params, this.props.duration),
            type: TABLE_TYPES_FOR_ENDPOINT.broad,
            label: LABELS_FOR_TABLE_TYPES.questions,
        };
    };

    protected transformData = (data: IGoogleKeywordGeneratorApiResponse) => {
        const countryName = CountryService.getCountryById(this.props.country).text;
        const durationText = DurationService.getFormattedDateOutOfDurationParam(this.props.duration, shortMonthAndYear);
        return {
            ...data,
            records: data.records.map((keywordGroupDetail) => {
                return {
                    ...keywordGroupDetail,
                    averageVolume: getVolumeValue(keywordGroupDetail.averageVolume),
                    monthlyVolume: getVolumeValue(keywordGroupDetail.monthlyVolume),
                    windowVolume: getVolumeValue(keywordGroupDetail.windowVolume),
                    SearchTerm: keywordGroupDetail.keyword,
                    url: this.getUrlForKeyWord(keywordGroupDetail.keyword),
                    country: this.props.country,
                    countryName,
                    durationText,
                    web_source: this.props.webSource,
                    organicShare: keywordGroupDetail.paidShare === 0 ? 1 : keywordGroupDetail.organicShare,
                    intents: {
                        PrimaryIntent: capitalizeIntent(keywordGroupDetail.primaryIntent),
                        SecondaryIntent: capitalizeIntent(keywordGroupDetail.secondaryIntent),
                    },
                };
            }),
        };
    };
}

export default connect(
    mapStateToPropsBase,
    mapDispatchToPropsBase,
)(KeywordGeneratorToolPageQuestionsTable as React.ComponentType<any>);
function getVolumeRangeFilterKey(params: any, duration: string) {
    throw new Error("Function not implemented.");
}
